<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid"/> Active Life Policies
      </CCardHeader>
      <PoliciesTable />
    </CCard> 
  </div>
</template>

<script>
import PoliciesTable from "@/components/LifeTable"
export default {
  components:{
    PoliciesTable
  }
}
</script>

<style>

</style>